import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { DesktopNavigationState } from './states/DesktopNavigationState';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import classNames from 'classnames';
import { DesktopUserInfo } from '../../../commonv3/components/organisms/navigation/DesktopUserInfo';
import { EnhancedLocationDescriptor, V3Routes } from '../../routes';
import { routingStore } from '../../../common/stores/routing';
import './desktopHeader.module.scss';
import { LabelText } from '@sheinc/shelikes-design-system';

const Separator = () => <div styleName="separator"></div>;

type PopupMenuItemProps = {
  to: EnhancedLocationDescriptor;
  children: React.ReactNode;
  openInNewTab?: boolean;
};

const PopupMenuItem = ({ to, children, openInNewTab = false }: PopupMenuItemProps) => {
  return (
    <div
      styleName="menu-item"
      onClick={() => (openInNewTab ? window.open(to.pathname, '_blank') : routingStore.push(to))}
    >
      <LabelText size="M">{children}</LabelText>
    </div>
  );
};

type PopupMenuProps = {
  show: boolean;
  onMouseLeave: () => void;
};

const PopupMenu = ({ show, onMouseLeave }: PopupMenuProps) => {
  const currentUser = GlobalStatesV3.currentUser;
  return (
    <div id="popup-menu" styleName={classNames('popup-menu', { show })} onMouseLeave={onMouseLeave}>
      <div styleName="hover-area" />
      <PopupMenuItem to={V3Routes.profile()}>プロフィールを編集</PopupMenuItem>
      <PopupMenuItem to={V3Routes.reservations()}>予約の確認</PopupMenuItem>
      <Separator />
      <PopupMenuItem to={V3Routes.plan()}>プランの確認 / 変更</PopupMenuItem>
      {!currentUser.isMultiCreatorUser() && (
        <PopupMenuItem to={V3Routes.multiCreators()}>コースのアップグレード</PopupMenuItem>
      )}
      <PopupMenuItem to={V3Routes.address()}>住所の確認</PopupMenuItem>
      <PopupMenuItem to={V3Routes.payments()}>お支払い情報 / 変更</PopupMenuItem>
      <PopupMenuItem to={V3Routes.homeLocation()}>ホーム拠点の確認 / 変更</PopupMenuItem>
      <PopupMenuItem to={V3Routes.password()}>パスワードを変更</PopupMenuItem>
      <PopupMenuItem to={V3Routes.email()}>メールの設定</PopupMenuItem>
      <PopupMenuItem to={V3Routes.faq()} openInNewTab>
        よくあるご質問
      </PopupMenuItem>
      <PopupMenuItem to={V3Routes.signOut()}>ログアウト</PopupMenuItem>
    </div>
  );
};

// マイページリニューアルに伴って新しく設置する右端にユーザーアイコンがあるだけのヘッダー
export const DesktopHeader = observer(() => {
  const [pageState] = useState(new DesktopNavigationState());
  const [currentUser] = useState(GlobalStatesV3.currentUser);
  const { showPopup } = pageState;
  const pathname = GlobalStatesV3.routing.location.pathname;

  // 正規表現にマッチするURLの時ヘッダーをグレーにする
  const isBgGray = pathname.match(
    /(courses\/\d)|(lesson_homework_submissions\/.+)|(lesson_homeworks\/\d{1,}\/submissions\/new)|(exam_practical_section_submissions\/.+)|(exam_practical_sections\/.+)|(exam_writing_sections\/.+)/
  );

  return (
    <div styleName={classNames('desktop-header', { gray: isBgGray })}>
      <div styleName="user-info-wrap">
        <DesktopUserInfo
          currentUser={currentUser}
          active={pageState.showPopup}
          onMouseEnter={() => pageState.openPopup()}
        />
      </div>
      <PopupMenu show={showPopup} onMouseLeave={() => pageState.closePopup()} />
    </div>
  );
});
